import React from "react"
import { useTranslation } from "react-i18next"
import { Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import { ReactComponent as Exclamation } from "../../icon/exclamation.svg"
import BobbingIcon from "../common/BobbingIcon"
import BlueButton from "../buttons/BlueButton"

interface SizeRejectionModalProps {
  show: boolean
  minWidth: number
  minHeight: number
  onHide: () => void
}

export default function SizeRejectionModal({
  show,
  minWidth,
  minHeight,
  onHide,
}: SizeRejectionModalProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={show}
      onClose={onHide}
      slotProps={{ paper: { sx: { borderRadius: "0.7rem", color: "#323232", maxWidth: 480 } } }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <BobbingIcon
          horizontalOffset="-23px"
          verticalOffset="-20px"
        >
          <Exclamation />
        </BobbingIcon>
        <Typography fontSize={28} fontWeight={500}>{t("sizeRejection.heading")}</Typography>
        <Typography fontSize={18} fontWeight={400} sx={{ mt: 1 }}>
          {t("sizeRejection.text", { width: minWidth, height: minHeight })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <BlueButton onClick={onHide}>
          {t("sizeRejection.buttonTitle")}
        </BlueButton>
      </DialogActions>
    </Dialog>
  )
}
